﻿import React, { useState, useEffect } from 'react';
import { CalibrationDate } from '../../models/Metrology/calibration-date';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import DmaFooter from '../DmaFooter';
import { PWDates } from '../../utilities/pw-dates';
import { DateFilterRequest } from '../../models/Common/date-filter-request';
import { CrudFunctions } from '../../utilities/crud-functions';

import DataGrid, {
    Column,
    FilterRow,
    HeaderFilter,
    SearchPanel,
    LoadPanel,
    Toolbar,
    Export,
    Item as ToolbarItem,
    Paging
} from 'devextreme-react/data-grid';

import Scheduler, { SchedulerTypes, Resource } from 'devextreme-react/scheduler';
import TileView from 'devextreme-react/tile-view';
import DateBox from 'devextreme-react/date-box';
import Button from 'devextreme-react/button';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';

const views: SchedulerTypes.ViewType[] = ['day', 'workWeek', 'month'];

//temp
const departments = [
    { id: "Schmitt", text: 'R & D', color: "#727bd2" },
    { id: "Carrell", text: 'Manufacturing', color: "#32c9ed" },
    { id: "Barta", text: 'QAQC', color: "#2a7ee4" },
    { id: "Cua", text: 'Finance', color: "#7b49d3" },
    { id: "Temple", text: 'Planning', color: "#727bd2" }
];

export default function UpcomingCalibrationsScheduler() {
    const [startDate, setStartDate] =
        useState<Date>();

    const [endDate, setEndDate] =
        useState<Date>();

    const [calibrationDates, setCalibrationDates] =
        useState<CalibrationDate[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        setInitialDates();
    }, []);

    return (
        <div className="pw-form-container">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Upcoming Calibrations</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-comp-row">
                {/*
                    KEEP - and enable option of selecting a month
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Product Type</div>
                    <SelectBox id="mobilePhaseType" className="textbox"
                        dataSource={productTypes ? productTypes : []}
                        valueExpr='id' displayExpr="name"
                        onValueChanged={onProductTypeChanged}
                        value={selectedProductType ? selectedProductType : undefined} />
                </div>
                */}
                <div className="pw-form-unit pw-comp-10">
                    <div className="pw-form-unit-label">Start Date</div>
                    <DateBox id="startDate" className="textbox"
                        onValueChanged={onStartDateChanged}
                        value={startDate ? startDate : undefined} />
                </div>

                <div className="pw-form-unit pw-comp-10">
                    <div className="pw-form-unit-label">End Date</div>
                    <DateBox id="endDate" className="textbox"
                        onValueChanged={onEndDateChanged}
                        value={endDate ? endDate : undefined} />
                </div>

                <div className="pw-row-button-08">
                    <Button className="title-bar-button"
                        text="Search" icon="search" type="success"
                        hint="get upcoming calibrations by filter"
                        onClick={onGetUpcomingCalibrationsClick} />
                </div>

                <div id="upcomingCalibrationsMenu" className="pw-margin-top-05 pw-right-align-content">
                    <TileView direction="horizontal" items={departments} height="2.5rem"
                        baseItemHeight={40} itemMargin={4}
                        itemRender={departmentItemRender} />
                </div>
            </div>

            <div>
                <Scheduler
                    dataSource={calibrationDates ? calibrationDates : []}
                    views={views}
                    defaultCurrentView="month"
                    height={600}
                    startDayHour={9}
                    endDayHour={19}
                    startDateExpr="dateNextCalibration"
                    endDateExpr="dateNextCalibration"
                    textExpr="assetNumber"
                    appointmentTooltipComponent={calibrationDateTooltip}>

                    <Resource
                        dataSource={departments}
                        allowMultiple={true}
                        fieldExpr="lastName"
                        label="Department"
                        useColorAsDefault={true}
                    />
                </Scheduler>
                
                {/*    
                dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"
                timeZone="America/Los_Angeles"
            */}
            </div>

            <div className="pw-margin-top-1">
                <DataGrid
                    height="16rem" width="100%"
                    dataSource={calibrationDates ? calibrationDates : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    onExporting={onExporting}
                    columnResizingMode='widget'
                    keyExpr="calibrationRequirementId"
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging enabled={false} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <Export enabled={true} allowExportSelectedData={true} />
                    <SearchPanel visible={true} />

                    <Column dataField='assetNumber' dataType='string' width='10rem' />
                    <Column dataField='description' dataType='string' width='30rem' />

                    <Column dataField='lastName' caption="Staff Last Name" dataType='string' width='10rem' />
                    <Column dataField='firstName' caption="Staff First Name" dataType='string' width='10rem' />
                    <Column dataField='dateNextCalibration' dataType='date' width='15rem'
                        format="MM/dd/yyyy" cellRender={renderCalibrationDateCell} />
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='after' name="exportButton" />
                        <ToolbarItem location='after' name="searchPanel" />
                    </Toolbar>

                </DataGrid>
            </div>

            <DmaFooter />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function setInitialDates() {
        const date = new Date();
        let laterDate = new Date();

        setStartDate(date);

        laterDate.setMonth(date.getMonth() + 1);
        setEndDate(laterDate);
    }

    function onStartDateChanged(e: any) {
        setStartDate(e.value);
    }

    function onEndDateChanged(e: any) {
        setEndDate(e.value);
    }

    async function onGetUpcomingCalibrationsClick() {
        //todo add check for values

        let request: DateFilterRequest = {
            startDate: startDate,
            endDate: endDate,
            //month: 
        };

        await getCalibrationDates(request)
            .then((data) => {
                console.log("calibrationDates::");
                console.log(data);

                setCalibrationDates(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Inserting Method");
            });
    }

    function getCalibrationDates(request: DateFilterRequest) {
        return CrudFunctions.postData("metrology/upcomingcalibrations", request);
    }

    function renderCalibrationDateCell(cellData: any) {
        const currentDate = new Date();
        const dateNextCalibration = cellData.data.dateNextCalibration;

        if (dateNextCalibration) {
            const daysDifference = PWDates.getDifferenceInDays(currentDate, new Date(dateNextCalibration))

            if (daysDifference >= 30)
                return (<div className="validation-pass">{PWDates.getLocalDateString(dateNextCalibration)}</div>);
            else if (daysDifference < 30 && daysDifference > 0)
                return (<div className="validation-warn">{PWDates.getLocalDateString(dateNextCalibration)}</div>);
            else
                return (<div className="validation-fail">{PWDates.getLocalDateString(dateNextCalibration)}</div>);
        }
        else {
            return (<div className="validation-fail">NA</div>);
        }
    }

    function calibrationDateTooltip(e: any) {
        return (
            <div className="movie-tooltip">
                <div className="movie-info">
                    <div className="pw-title-1">{e.data.appointmentData.assetNumber}</div>
                    <div>{e.data.appointmentData.description}</div>
                    <div>Staff: {e.data.appointmentData.firstName} {e.data.appointmentData.lastName}</div>
                </div>
            </div>
        );
    }

    //exporting

    function onExporting(e: any) {
        const name = "Calibrations Schedule";

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${name}.xlsx`);
            });
        });

        e.cancel = true;
    }

    function departmentItemRender(data: any) {
        return (
            <div> 
                <div style={{color:"#fff", backgroundColor: data.color, padding: "0.4rem"}}>{data.text}</div>
            </div>
        );
    }

    function goBack() {
        history.back();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
